import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { DecimatePipe } from '../pipes/decimate.pipe';

@Directive({
  selector: '[DigitsOnly]',
  providers: [
    DecimatePipe
  ]
})
export class DigitsOnlyDirective {


  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];
  inputElement: HTMLElement;
  constructor(public el: ElementRef, private decimalPipe: DecimatePipe, private renderer: Renderer2
    ) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
      (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
      (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {

      if (e.keyCode !== 190){ // allow decimal at this stage or else
        e.preventDefault();
      }
      // this.renderer.setStyle(this.el.nativeElement,'text-align','right')


    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput: string = event.clipboardData
      .getData('text/plain')
      .replace(/\D/g, ''); // get a digit-only string
    document.execCommand('insertText', false, pastedInput);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
    this.inputElement.focus();
    document.execCommand('insertText', false, textData);
  }


  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    if (value.length > 0){
      this.el.nativeElement.value = this.decimalPipe.transform(value);
    }else{
      this.el.nativeElement.value = this.decimalPipe.transform('0');
    }

    //  this.renderer.setStyle(this.el.nativeElement,'text-align','right')
  }

  // @HostListener("keydown", ["$event"])
  // onKey(value) {
  //   //this.el.nativeElement.value = this.decimalPipe.transform(value, '1.2');
  //   // this.renderer.setStyle(this.el.nativeElement,'text-align','right')

  // }
}
